module.exports = "./assets/assets/相关政策规定.6b80231c.doc";